import React, { useEffect, useRef, useState } from "react";

const VerifyCode = ({ onComplete }) => {
    const length = 6;
    const [values, setValues] = useState(Array(length).fill(""));
    const inputsRef = useRef([]);

    const handleChange = (e, index) => {
        const val = e.target.value;
        if (/^\d?$/.test(val)) {
            const newValues = [...values];
            newValues[index] = val;
            setValues(newValues);

            if (val && index < length - 1) {
                inputsRef.current[index + 1].focus();
            }

            if (newValues.every(v => v !== "")) {
                onComplete(newValues.join(""));
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData("text");
        const digits = paste.replace(/\D/g, "").slice(0, length).split("");

        if (digits.length === 0) return;

        const newValues = [...values];
        for (let i = 0; i < digits.length; i++) {
            newValues[i] = digits[i];
            if (inputsRef.current[i]) {
                inputsRef.current[i].value = digits[i]; // update DOM immediately
            }
        }

        setValues(newValues);

        const nextIndex = digits.length >= length ? length - 1 : digits.length;
        if (inputsRef.current[nextIndex]) {
            inputsRef.current[nextIndex].focus();
        }

        if (digits.length === length) {
            onComplete(digits.join(""));
        }
    };


    useEffect(() => {
        if (inputsRef.current[0]) {
            inputsRef.current[0].focus();
        }
    }, []);

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !values[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    return (
        <ul style={{ display: "flex", gap: "10px", justifyContent: "center", padding: 0 }}>
            {values.map((value, index) => (
                <li key={index} style={{ listStyle: "none" }}>
                    <input
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={value}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (inputsRef.current[index] = el)}
                        onPaste={handlePaste}
                        style={{
                            width: "40px",
                            height: "50px",
                            fontSize: "24px",
                            textAlign: "center",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                        }}
                    />
                </li>
            ))}
        </ul>
    );
};

export default VerifyCode;
